import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { CORE_PROJECT_FIELDS } from "../fragments/project";
import {
  GetProjectsByOrganizationId,
  GetProjectsByOrganizationIdVariables,
} from "./__generated__/GetProjectsByOrganizationId";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";
import { ORG_ROLE_FIELDS } from "../fragments/OrgRole";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";
import { CORE_ORGANIZATION_FIELDS } from "../fragments/organization";
import { CORE_PERMIT_TYPE_FIELDS } from "../fragments/PermitType";

export const GET_PROJECTS_BY_ORGANIZATION_ID = gql`
  ${CORE_PROJECT_FIELDS}
  ${PERMIT_TEMPLATE_FIELDS}
  ${ORG_ROLE_FIELDS}
  ${CORE_PERMIT_REGISTER_FIELDS}
  ${CORE_ORGANIZATION_FIELDS}
  ${CORE_PERMIT_TYPE_FIELDS}
  query GetProjectsByOrganizationId($organizationId: String!, $searchString: String, $skip: Int, $take: Int) {
    projectsByOrganizationId(organizationId: $organizationId, searchString: $searchString, skip: $skip, take: $take) {
      totalCount
      items {
        ...CoreProjectFields
        boundaries {
          coordinates
          crs
          type
        }
        organization {
          ...CoreOrganizationFields
        }
        maxProjectAssignments
        permitRegisters {
          ...CorePermitRegisterFields
          permitTypes {
            ...CorePermitTypeFields
            template {
              ...PermitTemplateFields
            }
            roles {
              id
              orgRole {
                ...OrgRoleFields
              }
              settings {
                isPermitAssignee
                mandatoryOnSubmission
                shouldAuthorizePermit
                authorizationDeclaration
              }
            }
          }
        }
      }
    }
  }
`;

export function useLazyGetProjectsByOrganizationId() {
  const [getProjectsByOrganizationId, { loading, error, data }] = useLazyQuery<
    GetProjectsByOrganizationId,
    GetProjectsByOrganizationIdVariables
  >(GET_PROJECTS_BY_ORGANIZATION_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getProjectsByOrganizationId,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
